import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { object } from 'prop-types'
import { navigate } from '@reach/router'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import Button from '@taglivros/oef_componentes/build/components/button'
import Input from '@taglivros/oef_componentes/build/components/input'
import { useGlobal } from '../../contexts/GlobalContext'
import { navigateParaAdaComRedirect, navigateParaDestinoPosLogin } from '../../utils/rotas/navigate'
import {
  BOTAO_CONFIRMAR,
  DESCRICAO_REDEFINIR_SENHA,
  LABEL_NOVA_SENHA,
  TITULO_REDEFINIR_SENHA
} from './constantsRedefinirSenha'
import { validacaoSenha } from '../../utils/validadores/validadores'
import { REQUIRED_MESSAGE, URLS } from '../../constants'
import { empty } from '../../utils/helpers/helpers'
import { useAssociado } from '../../contexts/AssociadoContext'
import InlineLoader from '../../components/InlineLoader/InlineLoader'


const WrapperRedefinirSenha = styled.section`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: calc(100vh - ${( { sucessoRequisicao } ) => sucessoRequisicao ? '135px' : '85px'});

  h1 {
    ${StyleGuide.boldFonte}
    font-size: 40px;
    margin-bottom: 20px;

    @media (min-width: ${StyleGuide.mediaQuery.mobile}) {
      font-size: 50px;
    }
  }

  h1, p {
    text-align: center;

    @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
      margin: 0 auto 20px;
      max-width: 280px;
    }
  }

  .wrapper_senha {
    margin: 30px auto 0;
    max-width: 280px;
    text-align: center;
    width: 100%;

    .form__row {
      margin-bottom: 25px;
    }

    @media (min-width: ${StyleGuide.mediaQuery.mobile}) {
      max-width: 450px;
    }
  }

  button {
    margin-top: 30px;
    z-index: 0;
  }

`

const RedefinirSenha = ( { location } ) => {
  const { isAssociadoLogado } = useGlobal()
  const { postRedefinirSenhaNaoLogado } = useAssociado()
  const [ valueInput, setValueInput ] = useState( {} )
  const [ erros, setErros ] = useState( {} )
  const [ sucessos, setSucessos ] = useState( {} )
  const [ botaoHabilitado, setBotaoHabilitado ] = useState( false )
  const [ magicLink, setMagicLink ] = useState()
  const redirectTo = new URLSearchParams( location.search ).get( 'redirectTo' )

  if ( isAssociadoLogado ) {
    navigateParaAdaComRedirect( redirectTo )
    return null
  }

  useEffect( () => {
    if ( sucessos.senha ) {
      setBotaoHabilitado( true )
    } else if ( erros.senha ) {
      setBotaoHabilitado( false )
    }
  }, [ sucessos ] )

  useEffect( () => {
    const magicLinkURL = location.search && location.search.includes( 'magicLink' )
    if ( magicLinkURL ) {
      const queryString = new URLSearchParams( location.search )
      const idMagicLink = queryString.get( 'magicLink' )
      setMagicLink( idMagicLink )
    } else {
      navigate( `/${URLS.ESQUECI_MINHA_SENHA}` )
    }
  }, [ location.search ] )

  const validador = event => {
    const { name, value } = event.target
    let validacaoErros = {}

    if ( value === '' ) {
      validacaoErros = {
        ...erros,
        [ name ]: REQUIRED_MESSAGE
      }
    } else if ( validacaoSenha( valueInput.senha ) ) {
      validacaoErros = {
        ...erros,
        [ name ]: validacaoSenha( valueInput.senha )
      }
    }

    setSucessos( {
      ...sucessos,
      [ name ]: empty( validacaoErros[ name ] ) && !empty( valueInput[ name ] )
    } )

    setErros( validacaoErros )
  }

  const handleChange = event => {
    const { name, value } = event.target

    setErros( {
      ...erros,
      [ name ]: null
    } )

    setSucessos( {
      ...sucessos,
      [ name ]: null
    } )

    setValueInput( {
      ...valueInput,
      [ name ]: value
    } )
  }

  const handleSubmit = async() => {
    if ( magicLink && valueInput.senha ) {
      const sucesso = await postRedefinirSenhaNaoLogado( { 'magic_link': magicLink, 'pwd': valueInput.senha } )
      if ( sucesso ) {
        navigateParaDestinoPosLogin( redirectTo )
      }
    }
  }

  return (
    <WrapperRedefinirSenha>
      { magicLink ?
        <>
          <h1>{ TITULO_REDEFINIR_SENHA }</h1>
          <p>{ DESCRICAO_REDEFINIR_SENHA }</p>
          <div
            className="wrapper_senha"
          >
            <Input
              erro={ erros.senha }
              isPassword
              label={ LABEL_NOVA_SENHA }
              name="senha"
              onBlur={ validador }
              onChange={ handleChange }
              sucesso={ sucessos.senha }
              testId="input-senha"
              tipo={ Input.TIPO_SENHA }
              value={ valueInput.senha }
            />
            <Button
              disabled={ !botaoHabilitado }
              onClick={ handleSubmit }
              testId="botao-enviar-redefinir-senha-nao-logado"
            >
              { BOTAO_CONFIRMAR }
            </Button>
          </div>
        </> : <InlineLoader isCenter />}
    </WrapperRedefinirSenha>
  )
}

RedefinirSenha.propTypes = {
  'location': object.isRequired
}

export default RedefinirSenha
